import { render, staticRenderFns } from "./catimuhasebekodu.vue?vue&type=template&id=84907426&scoped=true"
import script from "./catimuhasebekodu.vue?vue&type=script&lang=js"
export * from "./catimuhasebekodu.vue?vue&type=script&lang=js"
import style0 from "./catimuhasebekodu.vue?vue&type=style&index=0&id=84907426&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84907426",
  null
  
)

export default component.exports